// libraries
import React from "react";
import { Dropdown, Button } from "semantic-ui-react";
import PropTypes from "prop-types";
import moment from "moment";

// redux
import { connect } from "react-redux";

// components
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";
import Text from "@Components/Text";

// utils
// import { getTimeLabel } from "@Utils/index";

// styles
import styles from "./styles.module.css";

const FilterForm = ({
	onFilter,
	onClose,

	estado,
	fechaEstado,
	setEstado,
	setFechaEstado,
	stateOptions,
	fechaEnd,
	setFechaEnd,
	agentName,
	today,
}) => {
	const handleClear = () => {
		setEstado([]);
		setFechaEstado("");
		setFechaEnd("");
	};

	const handlerFilter = () => {
		const params = {
			"state[]?": estado,
			startDate: fechaEstado
				? `${moment(fechaEstado).isValid() ? moment(fechaEstado).format("YYYY-MM-DD") : ""},${
						fechaEnd && moment(fechaEnd).isValid() ? ` ${moment(fechaEnd).format("YYYY-MM-DD")}` : ""
				  }`
				: "",
		};

		onFilter(params);
		onClose();
	};
	return (
		<IKModal
			iconName="filter"
			title={`Filtro Agente:  ${agentName}`}
			saveLabel="Buscar"
			noMode
			onClose={onClose}
			onSuccess={handlerFilter}
			size="tiny"
			headerButtons={[
				<div className={styles.headerButtons}>
					<Button
						className={styles.clean}
						icon="trash"
						onClick={() => {
							handleClear();
						}}>
						Limpiar
					</Button>
				</div>,
			]}>
			<div className={styles.container}>
				<div className={styles.rowColumn}>
					<div className={styles.rowColumn2}>
						<Text className={styles.label}>Estado</Text>
						<Dropdown
							placeholder="Selecciona un estado"
							fluid
							search
							selection
							options={stateOptions}
							value={estado}
							onChange={(e, { value }) => {
								return setEstado(value);
							}}
							multiple
						/>
					</div>
					<Text className={styles.label}>Inicio</Text>
					<div className={styles.dateDiv}>
						<div className={styles.rowColumn2}>
							<Text className={styles.label}>Desde</Text>
							<Input
								type="date"
								icon="calendar"
								iconPosition="left"
								placeholder="Fecha Estado"
								value={fechaEstado}
								onChange={(e) => {
									return setFechaEstado(e.target.value);
								}}
							/>
						</div>
						<div className={styles.rowColumn2}>
							<Text className={styles.label}>Hasta</Text>
							<Input
								type="date"
								icon="calendar"
								iconPosition="left"
								placeholder="Fin"
								max={today}
								min={moment(fechaEstado).format("YYYY-MM-DD")}
								value={fechaEnd}
								onChange={(e) => {
									return setFechaEnd(e.target.value);
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</IKModal>
	);
};

FilterForm.propTypes = {
	onFilter: PropTypes.func,
	onClose: PropTypes.func,
	estado: PropTypes.string,
	fechaEstado: PropTypes.string,
	setEstado: PropTypes.func,
	setFechaEstado: PropTypes.func,
	stateOptions: PropTypes.array,
	fechaEnd: PropTypes.string,
	setFechaEnd: PropTypes.func,
	agentName: PropTypes.string,
	today: PropTypes.string,
};

function mapStateToProps() {
	return {};
}
export default connect(mapStateToProps)(FilterForm);
